export default {
  meta: {
    title: '配置管理'
  }
};
